import React, { Component } from 'react';
import PropTypes from 'prop-types';
import HForm, { TextAreaField } from 'shared/containers/portal_layout/HForm';
import { reduxForm } from 'utils/reduxFormWrapper';
import FlashMessageActions from 'shared/actions/FlashMessageActions';
import api from 'utils/api';
import { decamelizeKeys } from 'humps';
import Errors from 'shared/components/Errors';
import SpinnerButton from 'shared/components/SpinnerButton';

class AppointmentNoShower extends Component {
  constructor(props, context) {
    super(props, context);
    this.noShowAppointment = this.noShowAppointment.bind(this);
  }

  noShowAppointment(formValues) {
    return api
      .post(
        `${this.props.apiEndpoint}/appointments/${this.props.appointmentId}/no_shows`,
        decamelizeKeys(formValues)
      )
      .then(response => {
        this.props.handleSuccess();
        FlashMessageActions.flashSuccess({
          message: 'You have successfully marked this appointment as a no show',
        });
      });
  }

  render() {
    return (
      <FormifiedPresentationComponent form="appointmentNoShow" onSubmit={this.noShowAppointment} />
    );
  }
}

AppointmentNoShower.propTypes = {
  apiEndpoint: PropTypes.string.isRequired,
  handleSuccess: PropTypes.func.isRequired,
};

const PresentationComponent = props => (
  <HForm onSubmit={props.handleSubmit}>
    <div className="modal-header">
      <h3>No Show Appointment</h3>
    </div>
    <div className="modal-body" style={{ width: '600px' }}>
      <Errors errors={props.error || []} />
      <TextAreaField name="reason" label="No Show Reason" />
    </div>
    <div className="modal-footer">
      <SpinnerButton type="submit" className="btn btn-primary" loading={props.submitting}>
        No Show Appointment
      </SpinnerButton>
    </div>
  </HForm>
);

PresentationComponent.displayName = 'PresentationComponent';

const FormifiedPresentationComponent = reduxForm({})(PresentationComponent);

export default AppointmentNoShower;
